export default __webpack_public_path__ + "static/media/scanning-inheriting.8cfd6d3e.svg";